module.exports = [{
      plugin: require('/Users/kations/Projekte/Spicy/spicy-next/node_modules/gatsby-plugin-react-native-web/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/kations/Projekte/Spicy/spicy-next/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
